import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

const ItemStyle = styled.div`
  display: flex;
  margin: 5px 0px 5px 0px;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${props => props.theme.colors.grey1};
    cursor: pointer;
  }
`

const StyledAnchor = styled.a`
  color: ${props => props.theme.colors.black1};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

export const UserDropdownItem = props => {
  const dest = props.dest || '/not-found'

  return (
    <ItemStyle>
      <Link key={props.label} href={dest}>
        <StyledAnchor onClick={props.callback}>{props.label}</StyledAnchor>
      </Link>
    </ItemStyle>
  )
}
